/*
 * @file: 手动发送曝光
 */
import {sendExposureLog} from './exposure';

export function baseSendExposure(params: Record<string, any>) {
    const logDiv = document.createElement('div');
    logDiv.dataset.show = JSON.stringify({...params});
    sendExposureLog(logDiv);
}
